import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { DetailPageTitle } from 'src/common/components/AppLayout/DetailsPage/DetailsPageTitle';
import { PageLayout } from 'src/common/components/AppLayout/PageLayout';
import { Routes } from 'src/Routes.constants';
import { SimProductDetailsTabsLayout } from './SimProductDetailsTabsLayout';

type SimDetailsRoutingParams = {
  iccid?: string;
};

const SimProductDetailsPageTitle = () => {
  const { t } = useTranslation();
  const { iccid } = useParams<SimDetailsRoutingParams>();

  return (
    <DetailPageTitle
      title={`${t('simInventory.sim')} ${iccid}`}
      rootLocation={{
        to: Routes.productsSim,
        name: t('products.sim.simProducts'),
      }}
      currentLocationName={t('simInventory.SIMDetails')}
    />
  );
};

export const SimProductDetailsPageLayout = ({ children }: { children: React.ReactNode }) => {
  return (
    <PageLayout title={<SimProductDetailsPageTitle />}>
      <SimProductDetailsTabsLayout>{children}</SimProductDetailsTabsLayout>
    </PageLayout>
  );
};
